import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-crm-terms',
  templateUrl: './crm-terms.component.html',
  styleUrls: ['./crm-terms.component.scss']
})
export class CrmTermsComponent    {

}